import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './alcohol.json'; // The JSON you provided

const Alcohol = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Social drinking culture, health effects, and related vocabulary. B2 English exercises with grammar, reading, and discussion."
            level="B2"
            title="Alcohol"
            image="/Images/alcohol.webp"
            seoTitle="Free English Lesson Plans: Alcohol"
            seoDescription="Social drinking culture, health effects, and related vocabulary. B2 English exercises with grammar, reading, and discussion."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Alcohol;


